export default "__VITE_ASSET__DxsFP4um__"